import { BackendResponse } from "../BackendResponse";
import { withNextApi } from "../nextApiHelpers";

export interface GetCustomerTimesheetDraftVisibilityResponse extends BackendResponse {
  item: boolean;
}

export interface GetCustomerTimesheetDraftVisibilityParameters {
  assignmentId: number;
}

export const getCustomerTimesheetDraftVisibility = withNextApi<
  GetCustomerTimesheetDraftVisibilityResponse,
  GetCustomerTimesheetDraftVisibilityParameters
>("/CvpSettings/GetCustomerTimesheetDraftVisibility", { method: "GET" });
